import Padron from "./Padron";

export async function ObtengaDatosUsuario() {
  const usuarioLocal = localStorage.getItem("usuario");
  if (usuarioLocal) {
    return JSON.parse(usuarioLocal);
  }

  const usuario = await Padron.ObtengaDatosPersona();
  localStorage.setItem("usuario", JSON.stringify(usuario));
  return usuario;
}

export default {
  ObtengaDatosUsuario,
};
